import landingBackground from '../assets/images/impactboard-bg.jpg';
import dsdLandingBackground from '../assets/images/rmt-landing-page.jpg';
import nlLogo from '../assets/images/nl-logo.jpg';
import newNlLogo from '../assets/images/nl-new-logo.jpg';
import dsdLogo from '../assets/images/dsd-national-logo.jpg';
import impactBoardLogoTp from '../assets/images/impactboard-logo-tp.png';
import impactBoardLogo from '../assets/images/impactboard-logo.png';
import kstLogo from '../assets/images/kst-logo.png';
import insightsIcon from '../assets/images/DefaultInsightsIcon.png';
import insightsImage from '../assets/images/insights-image.svg';
import capsiLandingBackground from '../assets/images/capsi-landing-page.jpg';
import capsiLogo from '../assets/images/capsi-logo.png';

const images = {
  landingBackground,
  dsdLandingBackground,
  nlLogo,
  newNlLogo,
  dsdLogo,
  impactBoardLogoTp,
  impactBoardLogo,
  kstLogo,
  insightsIcon,
  insightsImage,
  capsiLandingBackground,
  capsiLogo,
};

export default images;
